export const defaultSdState = {
  sdTickets: [],
  sdTicket: null,
  sdLoading: false,
};
